var baseURL = '';
export const environment = {
  production: false,
  name: 'testing',
  appConfig: {
    apisBaseUrl: "https://gateway.miyarcapital.uk",
    notificationServiceBaseUrl: "https://notification.miyarcapital.uk",
    awsUrl: "https://mr-oss-dev-01.oss-me-central-1.aliyuncs.com/",
    moyassarPublishableKey: "pk_test_UD2aikfikR8nXZhcynGrBjDZ63dw3Lpcvb9Fwtpi"
  },
  mapKey: "AIzaSyDt-3iS_kTNAHFiFi32b2dSRU8NzlaWR8g",
};
